import React, { useEffect, useState } from "react";
import { Radio, RadioGroup, FormControl, FormControlLabel } from "@mui/material";
import styles from "./BooleanFilter.module.css";

const BooleanFilter = ({ trueLabel = "", falseLabel = "", filterKey, value, onChange }) => {
	const [currentValue, setCurrentValue] = useState(null);
	useEffect(() => {
		if (value?.value !== undefined) {
			setCurrentValue(value.value);
		}
	}, [value]);
	const handleChange = (e) => {
		const newValue = e.target.value === "true";
		setCurrentValue(newValue);
		onChange({ filterKey, value: newValue });
	};
	return (
		<div className={styles.main}>
			<FormControl>
				<RadioGroup value={currentValue} onChange={handleChange}>
					<FormControlLabel control={<Radio />} label={trueLabel} value="true" />
					<FormControlLabel control={<Radio />} label={falseLabel} value="false" />
				</RadioGroup>
			</FormControl>
		</div>
	);
};

export default BooleanFilter;
